"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Endpoints = exports.Endpoints = {
  blocked: {
    namespace: "UserBlacklist",
    actions: {
      add: {
        method: "POST",
        path: "blocks"
      },
      "delete": {
        method: "DELETE",
        path: "blocks/#{blocked_id}"
      }
    }
  },
  examining_boards: {
    namespace: "ExaminingBoard",
    actions: {
      list: {
        method: "GET",
        path: "examining_boards"
      },
      update: {
        method: "PUT",
        path: "examining_boards/#{slug}"
      }
    }
  },
  disciplines: {
    namespace: "Discipline",
    actions: {
      list: {
        method: "GET",
        path: "disciplines"
      }
    }
  },
  institutes: {
    namespace: "Institute",
    actions: {
      list: {
        method: "GET",
        path: "institutes"
      }
    }
  },
  jobs: {
    namespace: "Job",
    actions: {
      list: {
        method: "GET",
        path: "jobs"
      }
    }
  },
  favorites: {
    namespace: "Favorite",
    actions: {
      create: {
        method: "POST",
        path: "favorites"
      },
      "delete": {
        method: "DELETE",
        path: "favorites"
      }
    }
  },
  relationships: {
    namespace: "Relationship",
    actions: {
      create: {
        method: "POST",
        path: "relationships"
      },
      "delete": {
        method: "DELETE",
        path: "relationships"
      }
    }
  },
  users: {
    namespace: "User",
    custom: true,
    actions: {
      list: {
        method: "GET",
        path: "users"
      },
      show: {
        method: "GET",
        path: "users/#{user_id}"
      },
      update: {
        method: "PATCH",
        path: "users/#{user_id}"
      },
      send_email_confirmation: {
        method: "POST",
        path: "users/#{user_id}/send_email_confirmation"
      },
      give_bonus: {
        method: "POST",
        path: "users/#{user_id}/bonus"
      },
      restore: {
        method: "POST",
        path: "users/#{user_id}/restoration"
      },
      used_resources: {
        method: 'GET',
        path: "users/#{user_id}/used_resources"
      }
    }
  },
  user_profile: {
    namespace: "UserProfile",
    actions: {
      show: {
        method: "GET",
        path: "user_profile"
      },
      update: {
        method: "PATCH",
        path: "user_profile"
      }
    }
  },
  user_blacklist: {
    namespace: "UserBlacklist",
    actions: {
      create: {
        method: "POST",
        path: "user_blacklists"
      },
      "delete": {
        method: "DELETE",
        path: "user_blacklists/#{id}"
      }
    }
  },
  user_guides: {
    namespace: "UserGuide",
    actions: {
      create: {
        method: "POST",
        path: "user/guides"
      },
      "delete": {
        method: "DELETE",
        path: "user/guides/#{id}"
      }
    }
  },
  exams: {
    namespace: "Exam",
    custom: true,
    actions: {
      list: {
        method: "GET",
        path: "exams"
      },
      update: {
        method: "PUT",
        path: "exams/#{slug}"
      },
      request: {
        method: "POST",
        path: "exams/#{id}/exam_requests"
      }
    }
  },
  notebooks: {
    namespace: "Notebook",
    actions: {
      list: {
        method: "GET",
        path: "notebooks"
      },
      update: {
        method: "PUT",
        path: "notebooks/#{id}"
      },
      "delete": {
        method: "DELETE",
        path: "notebooks/#{id}"
      },
      create: {
        method: "POST",
        path: "notebooks"
      }
    }
  },
  notebooks_questions: {
    namespace: "NotebookQuestion",
    actions: {
      create: {
        method: "POST",
        path: "note_book/questions"
      },
      "delete": {
        method: "DELETE",
        path: "note_book/questions/#{id}"
      }
    }
  },
  stored_filters: {
    namespace: "StoredFilter",
    actions: {
      create: {
        method: "POST",
        path: "stored_filters"
      },
      show: {
        method: "GET",
        path: "stored_filters/#{id}"
      },
      "delete": {
        method: "DELETE",
        path: "stored_filters/#{id}"
      },
      list: {
        method: "GET",
        path: "stored_filters"
      }
    }
  },
  questions: {
    namespace: "Question",
    custom: true,
    actions: {
      resolve: {
        method: "POST",
        path: "questions/#{id}/resolve"
      },
      list: {
        method: "GET",
        path: "questions"
      },
      request_professor_commentary: {
        method: "POST",
        path: "professor_commentary_requests"
      }
    }
  },
  contests: {
    namespace: "Contest",
    actions: {
      list: {
        method: "GET",
        path: "contests"
      },
      show: {
        method: "GET",
        path: "contests/#{id}"
      }
    }
  },
  annotations: {
    namespace: "Annotation",
    actions: {
      create: {
        method: "POST",
        path: "annotations"
      },
      update: {
        method: "PUT",
        path: "annotations/#{id}"
      },
      "delete": {
        method: "DELETE",
        path: "annotations/#{id}"
      }
    }
  },
  lesson_annotations: {
    namespace: "LessonAnnotation",
    actions: {
      create: {
        method: "POST",
        path: "lesson_annotations"
      },
      update: {
        method: "PUT",
        path: "lesson_annotations/#{id}"
      },
      "delete": {
        method: "DELETE",
        path: "lesson_annotations/#{id}"
      }
    }
  },
  activities: {
    namespace: "Activity",
    custom: true,
    actions: {
      list: {
        method: "GET",
        path: "activities"
      },
      create: {
        method: "POST",
        path: "activities"
      },
      create_and_render: {
        method: "POST",
        path: "activities/create_and_render"
      },
      report_abuse: {
        method: "POST",
        path: "activities/#{id}/report_abuse"
      },
      "delete": {
        method: "DELETE",
        path: "activities/#{id}"
      }
    }
  },
  activity_comments: {
    namespace: "ActivityComments",
    custom: true,
    actions: {
      list: {
        method: "GET",
        path: "activities/#{activity_id}/comments"
      },
      create: {
        method: "POST",
        path: "activities/#{activity_id}/comments"
      },
      create_and_render: {
        method: "POST",
        path: "activities/#{activity_id}/comments/create_and_render"
      },
      update: {
        method: "PUT",
        path: "activities/#{activity_id}/comments/#{id}"
      },
      report_abuse: {
        method: "POST",
        path: "activities/#{activity_id}/comments/#{id}/report_abuse"
      },
      "delete": {
        method: "DELETE",
        path: "activities/#{activity_id}/comments/#{id}"
      }
    }
  },
  activity_replies: {
    namespace: "ActivityReplies",
    custom: true,
    actions: {
      list: {
        method: "GET",
        path: "activities/#{activity_id}/comments/#{activity_comment_id}/replies"
      },
      create: {
        method: "POST",
        path: "activities/#{activity_id}/comments/#{activity_comment_id}/replies"
      },
      create_and_render: {
        method: "POST",
        path: "activities/#{activity_id}/comments/#{activity_comment_id}/replies/create_and_render"
      },
      update: {
        method: "PUT",
        path: "activities/#{activity_id}/comments/#{activity_comment_id}/replies/#{id}"
      },
      report_abuse: {
        method: "POST",
        path: "activities/#{activity_id}/comments/#{activity_comment_id}/replies/#{id}/report_abuse"
      },
      "delete": {
        method: "DELETE",
        path: "activities/#{activity_id}/comments/#{activity_comment_id}/replies/#{id}"
      }
    }
  },
  question_errors: {
    namespace: "QuestionError",
    actions: {
      create: {
        method: "POST",
        path: "question_errors"
      }
    }
  },
  comment_feedbacks: {
    namespace: "CommentFeedback",
    actions: {
      create: {
        method: "POST",
        path: "comment_feedbacks"
      },
      update: {
        method: "PUT",
        path: "comment_feedbacks/#{id}"
      }
    }
  },
  practice_tests_questions: {
    namespace: "PracticeTestsQuestions",
    actions: {
      update: {
        method: "PUT",
        path: "practice_tests/#{practice_test_id}/practice_tests_questions/#{id}"
      }
    }
  },
  practice_tests: {
    namespace: "PracticeTest",
    custom: true,
    actions: {
      list: {
        method: "GET",
        path: "practice_tests"
      },
      update: {
        method: "PUT",
        path: "practice_tests/#{id}"
      },
      "delete": {
        method: "DELETE",
        path: "practice_tests/#{id}"
      },
      create: {
        method: "POST",
        path: "practice_tests"
      },
      correct: {
        method: "POST",
        path: "practice_tests/#{id}/correct"
      },
      create_and_render: {
        method: "POST",
        path: "practice_tests/#{id}/duplicate/create_and_render"
      }
    }
  },
  resolveds: {
    namespace: "Resolved",
    custom: true,
    actions: {
      mass_destroy_all: {
        method: "DELETE",
        path: "resolveds/mass_destroy_all"
      },
      mass_destroy: {
        method: "DELETE",
        path: "resolveds/mass_destroy"
      }
    }
  },
  commentaries: {
    namespace: "Commentary",
    custom: true,
    actions: {
      get_all: {
        method: "GET",
        path: "questions/#{question_id}/commentaries"
      },
      create: {
        method: "POST",
        path: "questions/#{question_id}/commentaries"
      },
      create_and_render: {
        method: "POST",
        path: "questions/#{question_id}/commentaries/create_and_render"
      },
      update: {
        method: "PUT",
        path: "questions/#{question_id}/commentaries/#{id}"
      },
      update_and_render: {
        method: "PUT",
        path: "questions/#{question_id}/commentaries/#{id}/update_and_render"
      },
      like: {
        method: "PUT",
        path: "questions/#{question_id}/commentaries/#{id}/like"
      },
      unlike: {
        method: "PUT",
        path: "questions/#{question_id}/commentaries/#{id}/unlike"
      },
      update_like: {
        method: "PUT",
        path: "questions/#{question_id}/commentaries/#{id}/update_like"
      },
      report_abuse: {
        method: "POST",
        path: "questions/#{question_id}/commentaries/#{id}/report_abuse"
      },
      "delete": {
        method: "DELETE",
        path: "questions/#{question_id}/commentaries/#{id}"
      }
    }
  },
  conversations: {
    namespace: "Conversation",
    custom: true,
    actions: {
      list: {
        method: "GET",
        path: "conversations"
      },
      create: {
        method: "POST",
        path: "conversations"
      },
      "delete": {
        method: "DELETE",
        path: "conversations/#{id}"
      },
      read_messages: {
        method: "PUT",
        path: "conversations/#{id}/read_messages"
      }
    }
  },
  messages: {
    namespace: "Message",
    custom: true,
    actions: {
      list: {
        method: "GET",
        path: "conversations/#{conversation_id}/messages"
      },
      create: {
        method: "POST",
        path: "conversations/#{conversation_id}/messages"
      },
      "delete": {
        method: "DELETE",
        path: "conversations/#{conversation_id}/messages/#{id}"
      },
      read: {
        method: "PUT",
        path: "conversations/#{conversation_id}/messages/#{id}/read"
      }
    }
  },
  lesson_feedbacks: {
    namespace: "LessonFeedback",
    actions: {
      create: {
        method: "POST",
        path: "lesson_feedbacks"
      },
      update: {
        method: "PUT",
        path: "lesson_feedbacks/#{id}"
      }
    }
  },
  carts: {
    namespace: "Cart",
    actions: {
      show: {
        method: "GET",
        path: "cart"
      },
      update: {
        method: "PATCH",
        path: "cart"
      },
      "delete": {
        method: "DELETE",
        path: "cart"
      }
    }
  },
  orders: {
    namespace: "Order",
    custom: true,
    actions: {
      list: {
        method: "GET",
        path: "orders"
      },
      show: {
        method: "GET",
        path: "orders/#{order_number}"
      },
      create: {
        method: "POST",
        path: "orders"
      },
      update: {
        method: "PATCH",
        path: "orders/#{order_number}"
      },
      "delete": {
        method: "DELETE",
        path: "orders/#{order_number}"
      },
      pay: {
        method: "POST",
        path: "orders/#{order_number}/payments"
      },
      refundPayment: {
        method: "POST",
        path: "orders/#{order_number}/payments/#{payment_id}/refund"
      }
    }
  },
  recurrences: {
    namespace: "Recurrence",
    custom: true,
    actions: {
      cancel: {
        method: "POST",
        path: "recurrences/#{id}/cancel"
      }
    }
  },
  cities: {
    namespace: "City",
    actions: {
      list: {
        method: "GET",
        path: "cities"
      }
    }
  },
  share: {
    namespace: "Share",
    actions: {
      create: {
        method: "POST",
        path: "share"
      }
    }
  },
  lessons: {
    namespace: "Lesson",
    actions: {
      list: {
        method: "GET",
        path: "lessons"
      }
    }
  },
  user_lesson_progress: {
    namespace: "UserLessonProgress",
    actions: {
      update: {
        method: "PATCH",
        path: "lessons/#{lesson_id}/progress"
      }
    }
  },
  user_preferences: {
    namespace: "UserPreference",
    actions: {
      show: {
        method: "GET",
        path: "user_preferences"
      },
      update: {
        method: "PATCH",
        path: "user_preferences"
      }
    }
  },
  deprecated_orders: {
    namespace: "DeprecatedOrders",
    actions: {
      list: {
        method: "GET",
        path: "deprecated_orders"
      }
    }
  },
  question_maintenances: {
    namespace: "QuestionMaintenances",
    actions: {
      create: {
        method: "POST",
        path: "ils/question_maintenances"
      }
    }
  },
  excerpts: {
    namespace: "Excerpts",
    actions: {
      list: {
        method: "GET",
        path: "ils/excerpts"
      }
    }
  }
};